import type { TypeOpsDeploy } from '@/types/ops/types.ops.deploy';
import type { TypeOpsTone } from '@/types/ops/types.ops.status';

export function opsDeployOutcome(deploy: Pick<TypeOpsDeploy, 'state' | 'conclusion'>): { tone: TypeOpsTone; key: string; final: boolean } {
    if (deploy.state === 'completed') {
        return deploy.conclusion === 'success'
            ? { tone: 'success', key: 'success', final: true }
            : { tone: 'danger', key: deploy.conclusion ?? 'failure', final: true };
    }
    if (deploy.state === 'failed') return { tone: 'danger', key: deploy.conclusion ?? 'startup_failure', final: true };
    return { tone: 'info', key: deploy.state, final: false };
}

export default opsDeployOutcome;
